import { useMutation } from "@tanstack/react-query";

import type { RpcClient } from "../../../../rpc-browser-sdk";

export function useAcceptDriverTermsAndConditions() {
    const mutation = useMutation({
        mutationKey: ["driverTermsAndConditions.acceptDriverTermsAndConditions"],
        mutationFn: (termsIds: string[]) => {
            // Importing getRpcClient dynamically to avoid circular dependencies
            const getRpcClient = require("../../../../rpc-browser-sdk").getRpcClient as () => RpcClient;
            return getRpcClient().driverTermsAndConditions.acceptDriverTermsAndConditions(termsIds);
        },
    });

    return {
        ...mutation,
        isLoading: mutation.isPending,
    };
}
